import style from "./Grid.module.css";

function Grid(props) {
  return <div className={`${style[`grid${props.no}`]}`}>
    {props.children}
  </div>;
}
export default Grid;
